import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as signalR from '@microsoft/signalr';
import { LocalStorageService } from '../local-storage.service';
import { Subject } from 'rxjs';
import { LoginService } from 'src/app/features/login/login.service';
import { Router } from '@angular/router';
import { BaseResponse } from 'src/app/model/response/base-response';


export interface hubRequest {
  username: string;
  status: boolean;
}

@Injectable({
  providedIn: 'root'
})

export class HubService {

  private hubConn!: signalR.HubConnection;

  // uniquie id for the connection so only this user will receive some specific messages
  private connectionId: string = "";

  public testDataSubject$: Subject<any> = new Subject<any>();

  constructor(
    private localStorageService: LocalStorageService,
    private loginService: LoginService,
    private router: Router,
  ) {

  }
  /********************************************************************************************************************* TO DO ***********************************************************/
  /************************************************************************************************************* CAMBIA IL LOG LEVEL *****************************************************/
  /********************************************************************************************************************* TO DO ***********************************************************/
  public startConnection() {
    // set ws protocol when using http and wss when using https
    /* OLD { 
      skipNegotiation: true, 
      transport: signalR.HttpTransportType.WebSockets 
    }*/
    //.withHubProtocol(signalR.HttpTransportType.WebSockets)
    //const location = window.location.host;
    this.hubConn = new signalR.HubConnectionBuilder()
      .withUrl(`${environment.hub}`)
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Trace)
      .build();

    this.hubConn.start()
      .then(() => {
        this.connectionId = this.hubConn.connectionId || "";
        console.warn("\n \n \n THIS THA Connection id: " + this.connectionId);
      })
      .then(() => {
        console.log("WebSocket Connection Successfuly created !!!! :) ");
      })
      .catch((err: any) => {
        console.error("Cannot create connection with websokcet :( ");
        console.log(err);
      });
  }

  public getTestData() {
    this.hubConn.on(`${environment.hubEndpoints.retst}`, (data: any) => {
      console.warn(data);
      if (this.localStorageService.isLogedIn()) {
        console.warn("GOT TEST DATA");
        console.warn(data);
        this.testDataSubject$.next(data);
      }
    });
  }


  public getUserState() {
    // azioni sullo stato utente (login, logout, ecc...)
    this.hubConn.on(environment.hubEndpoints.uState, (state: hubRequest) => {
      console.log("hub ustate: " + state);
      console.log(state);
      let session = this.localStorageService.getSession();
      if (state.status == false && state.username == session?.username) {
        if (session == null) {
          console.log("Utente già sloggato");
        }
        this.localStorageService.clearSession();
        this.router.navigate(['auth/login', { newConn: 'yes' }],);
      }
    });
  }

  /**
   * Set the id for the connection
   */
  /*private setConnectionId() {
    this.hubConn.invoke('getconnectionid')
    .then((data) => {
      console.warn(`\n \n \n THIS IS THE CONN ID ${data} \n \n`);
      this.connectionId = data;
    });
  }*/

  public getConnectionId(): string {
    return this.connectionId;
  }

}
